import { CheckCircleIcon, CloseIcon } from '@chakra-ui/icons';
import { useColorModeValue, Heading, Box, Stack,Text, FormControl, Input, Flex, HStack, Divider, Button, Select, Spinner } from '@chakra-ui/react';
import { FormEvent, useCallback, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { getUserByIdRequest, getUserResponse, updateUserRequest, updateUserResponse } from "../../../shared";
import { ENDPOINT_CONFIGS, withParams } from '../endpoints';
import { ApiError, callEndpoint } from '../fetch';
import { isAdmin, isLoggedIn } from '../fetch/auth';
import { ROUTES } from '../routes';
import { USER_STATUS } from '../types';


  export const ControlUser = ()=>{  
   const [error, setError] = useState('');
   const [searchId, setSearchId]= useState('');
   const [user, setUser]= useState({});
   const [userStatus, setUserStatus]= useState('');
   const [resOk,setResOk]=useState(false);
   const navigate = useNavigate();
   const [userId, setUserId]= useState('');
   const [busy, setBusy] = useState(false);


  const search = useCallback(
    async (e: FormEvent | MouseEvent) => {
      e.preventDefault();
     
      setBusy(true);
      setError('');
      let endPoint

      if ((searchId.length === 7) && !!Number(searchId)){
            endPoint=ENDPOINT_CONFIGS.getUserById;
      }
      
      else if ((searchId.length === 11) && !!Number(searchId)){
            endPoint=ENDPOINT_CONFIGS.getUserByPhone;
      }

      else if ((searchId.includes('@')) && (searchId.includes('.'))){
            endPoint=ENDPOINT_CONFIGS.getUserByEmail;
      } else{
     
        setError('Wrong search term');   
        setUser({});
        setBusy(false);
       return(<div></div>)
      }

   
      if (!isLoggedIn()) {
        navigate(ROUTES.SIGN_IN);
      }

      if (!isAdmin()) {
        navigate(ROUTES.HOME);
    }

      try{
        const res= await callEndpoint<getUserByIdRequest, getUserResponse>(withParams(endPoint, searchId!))

     
            setUser({
             "Id":res.id,
             "Name":res.name,
             "Email":res.email,
             "Address":res.address,
             "Phone":res.phone,
             "Status":res.status,
             "Kind":res.kind,
             "Notes":res.notes

            })                   
         
            setUserId(res.id);
        
            setUserStatus(res.status);
            setBusy(false);
         } catch (e) {
           setError((e as ApiError).message);
           setUser({});
           setBusy(false);
         }
  
        

    },
    [searchId,navigate,user]
  );

   

  const handleSubmit = useCallback(
    async (e: FormEvent | MouseEvent) => {
      e.preventDefault();
      
      setBusy(true);
      setResOk(false);
      try {
    
       await callEndpoint<updateUserRequest, updateUserResponse>((ENDPOINT_CONFIGS.updateUser), {
          id:userId,
          status:userStatus
        });


        setResOk(true);
        setError('');
        setBusy(false);
       // navigate(ROUTES.HOME);
      } catch (e) {

        setError((e as ApiError).message);
        setBusy(false);
      }
    },
    [userStatus]
  );
return(
      <div>
     <Flex
        minH={'100vh'}

        justify={'center'}
        bg={useColorModeValue('gray.50', 'gray.800')}>
        <Stack spacing={5} w={'full'} mx={'auto'} maxW={'lg'} py={5} px={6}>
          <Stack align={'center'}>
            <Heading fontSize={'2xl'} textAlign={'center'}>
              Control User
            </Heading>           
          </Stack>
          <Box
         rounded={'lg'}
         bg='white'
         boxShadow={'lg'}
         p={8}>  
        <Stack spacing={1}>
          
          <form onSubmit={search}>
          <fieldset disabled={busy}>
            <HStack paddingBottom={4}>
                <Box width={'full'}>
                  <FormControl id="searchid" isRequired>
                    <Input type="text" placeholder={'Id, email or phone'} onChange={e => setSearchId(e.target.value)}/>
                  </FormControl>
                </Box>
                <Box>
                <Button
                type='submit'               
                  loadingText="Submitting"
                  size="md"
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }} >
                  Search
                </Button>
                {busy &&  
                <Stack pt={4}>
                <Spinner  alignSelf={'center'} />
                </Stack>
                }
                </Box>            
            </HStack>        
            </fieldset> 
            </form>

         


            {Object.keys(user).map((key,i)=>(
              <div key={i}>
              <Flex id="id"direction={'row'}>                               
              <Text size={'xl'} fontWeight={'bold'}>{key}: </Text>
              <Text color='gray.600' size={'md'} pl={2}>{user[key]}</Text>   
            </Flex>
            <Divider orientation='horizontal' />  
             </div>
            ))}

            
</Stack>

                {!!userStatus &&
                <Stack pt={5}>
                <FormControl id="status" >
                  <HStack align={'center'}>
                <Text fontWeight={'bold'}>Status</Text>
                <Select dir={'ltr'} value={userStatus} onChange={e => setUserStatus(e.target.value)} > 
       
                    {Object.keys(USER_STATUS).map((key,i)=>(
                     
                      <option key={i} value={i}>{USER_STATUS[key]}</option>
                     
                    ))}
  
                 </Select>   
                 </HStack>
               </FormControl>

                <Stack spacing={10} pt={2}>
                <Button
                type='submit'               
                  loadingText="Submitting"
                  size="lg"
                  bg={'blue.400'}
                  color={'white'}
                  _hover={{
                    bg: 'blue.500',
                  }} onClick={handleSubmit}>
                  Update User
                </Button>
              </Stack>

          
              {resOk && <>
              <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                <CheckCircleIcon boxSize={'20px'} color={'green.500'} />                           
                <Text color="green">user update successfully</Text>               
              </Stack>
              </>
              }
              </Stack>
            }

              {!!error &&
                <Stack justifyContent={'center'} direction={'row'} spacing={2}>
                 <CloseIcon boxSize={'20px'} color={'white'} />
                <Text color="red.700">{error}</Text>             
                </Stack>
               }


</Box>

         
        </Stack>

      </Flex>
</div>
);
};


